import { renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-tab-id", "aria-hidden"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref: "tab",
    id: $setup.panelId,
    "data-tab-id": $setup.computedId,
    "aria-hidden": !$setup.isActive,
    class: _normalizeClass($props.panelClass),
    role: "tabpanel",
    tabindex: "-1"
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1)), [
    [_vShow, $setup.isActive]
  ])
}